<template>
    <div v-if="editor" class="mb-4">
        <a
            class="inline-flex items-center px-3 py-2 border border-transparent shadow-sm text-sm leading-4 font-medium rounded-md text-white bg-blue-400 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 border-1 rounded bg-white cursor-pointer w-10 h-8 text-center mr-1"
            @click="editor.chain().focus().toggleBold().run()"
            :class="{ 'font-bold bg-blue-600': editor.isActive('bold') }"
        >
            <span class="text-center w-full">B</span>
        </a>
        <a
            class="inline-flex items-center px-3 py-2 border border-transparent shadow-sm text-sm leading-4 font-medium rounded-md text-white bg-blue-400 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 border-1 rounded bg-white cursor-pointer w-10 h-8 text-center mr-1"
            @click="editor.chain().focus().toggleItalic().run()"
            :class="{ 'font-bold bg-blue-600': editor.isActive('italic') }"
        >
            <span class="text-center w-full"><em>I</em></span>
        </a>

        <a
            class="inline-flex items-center px-3 py-2 border border-transparent shadow-sm text-sm leading-4 font-medium rounded-md text-white bg-blue-400 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 border-1 rounded bg-white cursor-pointer w-10 h-8 text-center mr-1 hidden"
            @click="editor.chain().focus().toggleStrike().run()"
            :class="{ 'font-bold bg-blue-600': editor.isActive('strike') }"
        >
            <span
                style="text-decoration: line-through"
                class="text-center w-full"
                >S</span
            >
        </a>

        <a
            class="inline-flex items-center px-3 py-2 border border-transparent shadow-sm text-sm leading-4 font-medium rounded-md text-white bg-blue-400 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 border-1 rounded bg-white cursor-pointer w-10 h-8 text-center mr-1"
            @click="editor.chain().focus().toggleHeading({ level: 1 }).run()"
            :class="{
                'font-bold bg-blue-60': editor.isActive('heading', {
                    level: 1,
                }),
            }"
        >
            <span class="text-center w-full">H1</span>
        </a>

        <a
            class="inline-flex items-center px-3 py-2 border border-transparent shadow-sm text-sm leading-4 font-medium rounded-md text-white bg-blue-400 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 border-1 rounded bg-white cursor-pointer w-10 h-8 text-center mr-1"
            @click="editor.chain().focus().toggleHeading({ level: 2 }).run()"
            :class="{
                'font-bold bg-blue-60': editor.isActive('heading', {
                    level: 2,
                }),
            }"
        >
            <span class="text-center w-full">H2</span>
        </a>

        <a
            class="inline-flex items-center px-3 py-2 border border-transparent shadow-sm text-sm leading-4 font-medium rounded-md text-white bg-blue-400 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 border-1 rounded bg-white cursor-pointer w-10 h-8 text-center mr-1"
            @click="editor.chain().focus().toggleHeading({ level: 3 }).run()"
            :class="{
                'font-bold bg-blue-60': editor.isActive('heading', {
                    level: 3,
                }),
            }"
        >
            <span class="text-center w-full" n>H3</span>
        </a>

        <a
            class="inline-flex items-center px-3 py-2 border border-transparent shadow-sm text-sm leading-4 font-medium rounded-md text-white bg-blue-400 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 border-1 rounded bg-white cursor-pointer w-10 h-8 text-center mr-1"
            @click="editor.chain().focus().setParagraph().run()"
            :class="{ 'font-bold bg-blue-600': editor.isActive('paragraph') }"
        >
            <span class="text-center w-full">P</span>
        </a>

        <a
            class="inline-flex items-center px-3 py-2 border border-transparent shadow-sm text-sm leading-4 font-medium rounded-md text-white bg-blue-400 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 border-1 rounded bg-white cursor-pointer w-10 h-8 text-center mr-1 mt-1 font-bold"
            @click="editor.chain().focus().toggleBulletList().run()"
            :class="{ 'font-bold bg-blue-600': editor.isActive('bulletList') }"
        >
            <svg
                class="w-4 h-4"
                style="margin-top: -5px"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M4 6h16M4 10h16M4 14h16M4 18h16"
                ></path>
            </svg>
        </a>

        <a
            @click="setLink()"
            class="inline-flex items-center px-3 py-2 border border-transparent shadow-sm text-sm leading-4 font-medium rounded-md text-white bg-blue-400 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 border-1 rounded bg-white cursor-pointer w-10 h-8 text-center mr-1"
            :class="{ 'font-bold bg-blue-600': editor.isActive('link') }"
        >
            <svg
                class="w-4 h-4"
                fill="none"
                style="margin-top: -5px"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
                ></path>
            </svg>
        </a>
    </div>
    <editor-content :style="cssVars" class="mt-2" :editor="editor" />
</template>

<script>
import { Editor, EditorContent } from "@tiptap/vue-3";
import StarterKit from "@tiptap/starter-kit";

import Document from "@tiptap/extension-document";
import Paragraph from "@tiptap/extension-paragraph";
import Text from "@tiptap/extension-text";
import Heading from "@tiptap/extension-heading";
import Link from "@tiptap/extension-link";

export default {
    components: {
        EditorContent,
    },

    props: {
        modelValue: {
            type: String,
            default: "",
        },
        template_text: {
            type: String,
            default: "#4f99d6",
        },
        template_bg: {
            type: String,
            default: "#d1e9f9",
        },
    },

    data() {
        return {
            editor: null,
        };
    },

    watch: {
        modelValue(value) {
            // HTML
            const isSame = this.editor.getHTML() === value;

            // JSON
            // const isSame = JSON.stringify(this.editor.getJSON()) === JSON.stringify(value)

            if (isSame) {
                return;
            }

            this.editor.commands.setContent(value, false);
        },
    },
    computed: {
        cssVars() {
            return {
                "--tc": this.template_text,
            };
        },
    },

    mounted() {
        this.editor = new Editor({
            extensions: [
                StarterKit,
                Link.configure({
                    autolink: false,
                    linkOnPaste: true,
                }),
                // Document,
                // Paragraph,
                // Text,
                // Heading.configure({
                //     levels: [1, 2, 3],
                // }),
            ],
            content: this.modelValue,
            onUpdate: () => {
                // HTML
                this.$emit("update:modelValue", this.editor.getHTML());

                // JSON
                // this.$emit('update:modelValue', this.editor.getJSON())
            },
        });
    },
    methods: {
        setLink() {
            const previousUrl = this.editor.getAttributes("link").href;
            const url = window.prompt("Link", previousUrl);

            // cancelled
            if (url === null) {
                return;
            }

            // empty
            if (url === "") {
                this.editor
                    .chain()
                    .focus()
                    .extendMarkRange("link")
                    .unsetLink()
                    .run();

                return;
            }

            // update link
            this.editor
                .chain()
                .focus()
                .extendMarkRange("link")
                .setLink({ href: url })
                .run();
        },
    },

    beforeUnmount() {
        this.editor.destroy();
    },
};
</script>

<style lang="scss">
/* Basic editor styles */

.ProseMirror:focus {
    outline: none;
}

.ProseMirror {
    > * + * {
        margin-top: 0.75em;
    }

    ul,
    ol {
        padding: 0 1rem;
        list-style: disc;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        line-height: 1.1;
    }

    code {
        background-color: rgba(#616161, 0.1);
        color: #616161;
    }

    li p {
        margin-top: 0;
        margin-bottom: 0;
    }

    pre {
        background: #0d0d0d;
        color: #fff;
        font-family: "JetBrainsMono", monospace;
        padding: 0.75rem 1rem;
        border-radius: 0.5rem;

        code {
            color: inherit;
            padding: 0;
            background: none;
            font-size: 0.8rem;
        }
    }

    img {
        max-width: 100%;
        height: auto;
    }

    blockquote {
        padding-left: 1rem;
        border-left: 2px solid rgba(#0d0d0d, 0.1);
    }

    hr {
        border: none;
        border-top: 2px solid rgba(#0d0d0d, 0.1);
        margin: 2rem 0;
    }

    h1,
    h2,
    h3,
    h5,
    a {
        /* color: #4f99d6 !important; */
        color: var(--tc) !important;
    }
    a {
        text-decoration: underline;
    }
    h1 {
        font-size: 20px;
        font-weight: bold;
    }
    h2 {
        font-size: 18px;
        font-weight: bold;
    }
    h3 {
        font-size: 16px;
        font-weight: bold;
    }
}
</style>
